export default __webpack_public_path__ + "static/about-shape-f236349441c5f51cbb2739a1d80a96d1.png";